import React from "react";
import { Link } from "react-router-dom";

function GamePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 text-center bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 relative overflow-y-auto">
      {/* Modern background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_80%,rgba(120,119,198,0.1),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(255,119,198,0.1),transparent_50%)]"></div>
      
      <h1 className="text-4xl bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 bg-clip-text text-transparent font-extrabold mb-8 drop-shadow-md relative z-10">
        🎮 Choose a Fun Game!
      </h1>

      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-6 items-center justify-center w-full max-w-2xl relative z-10">
        {/* Alphabet Game */}
        <Link
          to="/alphabet-game"
          className="w-full sm:w-auto px-8 py-6 bg-gradient-to-br from-pink-400 to-pink-500 hover:from-pink-500 hover:to-pink-600 text-white text-lg font-bold rounded-2xl shadow-xl transition-all duration-300 flex items-center justify-center gap-2 hover:scale-105 hover:shadow-2xl border border-pink-300/30"
        >
          🔤 Alphabet Game
        </Link>

        {/* Flashcards Game */}
        <Link
          to="/flashcards"
          className="w-full sm:w-auto px-8 py-6 bg-gradient-to-br from-green-400 to-green-500 hover:from-green-500 hover:to-green-600 text-white text-lg font-bold rounded-2xl shadow-xl transition-all duration-300 flex items-center justify-center gap-2 hover:scale-105 hover:shadow-2xl border border-green-300/30"
        >
          🧠 Flashcards Game
        </Link>

        {/* Word Match Game */}
        <Link
          to="/word-match-game"
          className="w-full sm:w-auto px-8 py-6 bg-gradient-to-br from-blue-400 to-blue-500 hover:from-blue-500 hover:to-blue-600 text-white text-lg font-bold rounded-2xl shadow-xl transition-all duration-300 flex items-center justify-center gap-2 hover:scale-105 hover:shadow-2xl border border-blue-300/30"
        >
          🧩 Word Match Game
        </Link>

        {/* Alphabet Forms Card Game */}
        <Link
          to="/alphabet-forms-game"
          className="w-full sm:w-auto px-8 py-6 bg-gradient-to-br from-purple-400 to-purple-500 hover:from-purple-500 hover:to-purple-600 text-white text-lg font-bold rounded-2xl shadow-xl transition-all duration-300 flex items-center justify-center gap-2 hover:scale-105 hover:shadow-2xl border border-purple-300/30"
        >
          🃏 Alphabet Forms Game
        </Link>

        {/* Tracing Game */}
        <Link
          to="/tracing-game"
          className="w-full sm:w-auto px-8 py-6 bg-gradient-to-br from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white text-lg font-bold rounded-2xl shadow-xl transition-all duration-300 flex items-center justify-center gap-2 hover:scale-105 hover:shadow-2xl border border-yellow-300/30"
        >
          ✍️ Letter Tracing Game
        </Link>

        {/* Words Quiz */}
        <Link
          to="/words-quiz"
          className="w-full sm:w-auto px-8 py-6 bg-gradient-to-br from-indigo-400 to-indigo-500 hover:from-indigo-500 hover:to-indigo-600 text-white text-lg font-bold rounded-2xl shadow-xl transition-all duration-300 flex items-center justify-center gap-2 hover:scale-105 hover:shadow-2xl border border-indigo-300/30"
        >
          🧠 Words Quiz
        </Link>
      </div>
    </div>
  );
}

export default GamePage;
